import createReducer from '../../utils/createReducer';
import {
  LOGIN_REQUEST,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  SIGNUP_REQUEST,
  SIGNUP_FAILURE,
  SIGNUP_SUCCESS,
  SIGNUP_CONFIRMATION_REQUEST,
  SIGNUP_CONFIRMATION_FAILURE,
  SIGNUP_CONFIRMATION_SUCCESS,
  FORGOT_REQUEST,
  FORGOT_FAILURE,
  FORGOT_SUCCESS,
  FORGOT_CONFIRMATION_REQUEST,
  FORGOT_CONFIRMATION_FAILURE,
  FORGOT_CONFIRMATION_SUCCESS,
  LOGOUT_SUCCESS,
  VERIFY_REQUEST,
  VERIFY_FAILURE,
  VERIFY_SUCCESS,
} from './constants';

const initialState = {
  isFetching: false,
  isAuthenticated: false,
  loginErrorMessage: null,
  signupErrorMessage: null,
  signupSuccess: false,
  signupConfirmationErrorMessage: null,
  signupConfirmationSuccess: false,
  forgotErrorMessage: null,
  forgotSuccess: false,
  forgotConfirmationErrorMessage: null,
  forgotConfirmationSuccess: false,
  verifySuccess: false,
  user: {},
};

export default createReducer(initialState, {
  /**
   * LOGIN
   */

  [LOGIN_REQUEST](state, action) {
    const { isFetching, isAuthenticated, verifySuccess, user } = action;
    return Object.assign({}, state, {
      isFetching,
      isAuthenticated,
      verifySuccess,
      user,
    });
  },

  [LOGIN_FAILURE](state, action) {
    const { isFetching, isAuthenticated, loginErrorMessage } = action;
    return Object.assign({}, state, {
      isFetching,
      isAuthenticated,
      loginErrorMessage,
    });
  },

  [LOGIN_SUCCESS](state, action) {
    const { isFetching, isAuthenticated, loginErrorMessage } = action;
    return Object.assign({}, state, {
      isFetching,
      isAuthenticated,
      loginErrorMessage,
    });
  },

  /**
   * SIGNUP
   */

  [SIGNUP_REQUEST](state, action) {
    const { isFetching, isAuthenticated, signupSuccess, user } = action;
    return Object.assign({}, state, {
      isFetching,
      isAuthenticated,
      signupSuccess,
      user,
    });
  },

  [SIGNUP_FAILURE](state, action) {
    const {
      isFetching,
      isAuthenticated,
      signupErrorMessage,
      signupSuccess,
    } = action;
    return Object.assign({}, state, {
      isFetching,
      isAuthenticated,
      signupErrorMessage,
      signupSuccess,
    });
  },

  [SIGNUP_SUCCESS](state, action) {
    const {
      isFetching,
      isAuthenticated,
      signupErrorMessage,
      signupSuccess,
    } = action;
    return Object.assign({}, state, {
      isFetching,
      isAuthenticated,
      signupErrorMessage,
      signupSuccess,
    });
  },

  /**
   * SIGNUP CONFIRMATION
   */

  [SIGNUP_CONFIRMATION_REQUEST](state, action) {
    const {
      isFetching,
      signupConfirmationSuccess,
      isAuthenticated,
      user,
    } = action;
    return Object.assign({}, state, {
      isFetching,
      signupConfirmationSuccess,
      isAuthenticated,
      user,
    });
  },

  [SIGNUP_CONFIRMATION_FAILURE](state, action) {
    const {
      isFetching,
      signupConfirmationSuccess,
      signupConfirmationErrorMessage,
      isAuthenticated,
    } = action;
    return Object.assign({}, state, {
      isFetching,
      signupConfirmationSuccess,
      signupConfirmationErrorMessage,
      isAuthenticated,
    });
  },

  [SIGNUP_CONFIRMATION_SUCCESS](state, action) {
    const {
      isFetching,
      signupConfirmationSuccess,
      signupConfirmationErrorMessage,
      isAuthenticated,
    } = action;
    return Object.assign({}, state, {
      isFetching,
      signupConfirmationSuccess,
      signupConfirmationErrorMessage,
      isAuthenticated,
    });
  },

  /**
   * FORGOT
   */

  [FORGOT_REQUEST](state, action) {
    const { isFetching, forgotSuccess } = action;
    return Object.assign({}, state, { isFetching, forgotSuccess });
  },

  [FORGOT_FAILURE](state, action) {
    const { isFetching, forgotErrorMessage, forgotSuccess } = action;
    return Object.assign({}, state, {
      isFetching,
      forgotErrorMessage,
      forgotSuccess,
    });
  },

  [FORGOT_SUCCESS](state, action) {
    const { isFetching, forgotErrorMessage, forgotSuccess } = action;
    return Object.assign({}, state, {
      isFetching,
      forgotErrorMessage,
      forgotSuccess,
    });
  },

  /**
   * FORGOT CONFIRMATION
   */

  [FORGOT_CONFIRMATION_REQUEST](state, action) {
    const {
      isFetching,
      signupConfirmationSuccess,
      isAuthenticated,
      user,
    } = action;
    return Object.assign({}, state, {
      isFetching,
      signupConfirmationSuccess,
      isAuthenticated,
      user,
    });
  },

  [FORGOT_CONFIRMATION_FAILURE](state, action) {
    const {
      isFetching,
      forgotConfirmationSuccess,
      forgotConfirmationErrorMessage,
      isAuthenticated,
    } = action;
    return Object.assign({}, state, {
      isFetching,
      forgotConfirmationSuccess,
      forgotConfirmationErrorMessage,
      isAuthenticated,
    });
  },

  [FORGOT_CONFIRMATION_SUCCESS](state, action) {
    const {
      isFetching,
      forgotConfirmationSuccess,
      forgotConfirmationErrorMessage,
      isAuthenticated,
    } = action;
    return Object.assign({}, state, {
      isFetching,
      forgotConfirmationSuccess,
      forgotConfirmationErrorMessage,
      isAuthenticated,
    });
  },

  /**
   * LOGOUT
   */

  [LOGOUT_SUCCESS](state, action) {
    const { isFetching, isAuthenticated, user } = action;
    return Object.assign({}, state, { isFetching, isAuthenticated, user });
  },

  /**
   * VERIFY
   */

  [VERIFY_REQUEST](state, action) {
    const { isFetching, isAuthenticated } = action;
    return Object.assign({}, state, { isFetching, isAuthenticated });
  },

  [VERIFY_FAILURE](state, action) {
    const { isFetching, isAuthenticated } = action;
    return Object.assign({}, state, { isFetching, isAuthenticated });
  },

  [VERIFY_SUCCESS](state, action) {
    const { isFetching, isAuthenticated, verifySuccess, user } = action;
    return Object.assign({}, state, {
      isFetching,
      isAuthenticated,
      verifySuccess,
      user,
    });
  },
});



// WEBPACK FOOTER //
// ./src/containers/Auth/reducer.js